const tabMapping = new Map()
tabMapping.set('动态', 'dongtai')
tabMapping.set('热门', 'hot')
tabMapping.set('精华', 'selected')
tabMapping.set('价格讨论', 'pricediscuss')
tabMapping.set('质量反馈', 'quality')
tabMapping.set('评车', 'dakareyi')
tabMapping.set('商家', 'shangjia')
tabMapping.set('选买对比', 'xuanmai')
tabMapping.set('价格', 'price')
tabMapping.set('配置', 'config')
tabMapping.set('故障维修', 'maintenance')
tabMapping.set('用车', 'usecar')
tabMapping.set('买车讨论', 'buycar')
tabMapping.set('能耗分享', 'energy')
tabMapping.set('用车感受', 'cardrive')
tabMapping.set('提车分享', 'pickup')
tabMapping.set('车生活', 'cheyou')
tabMapping.set('改装', 'modification')
tabMapping.set('二手车', 'usedcar')
tabMapping.set('问答', 'wenda')
tabMapping.set('口碑', 'koubei')
tabMapping.set('懂车分(口碑)', 'koubei')
tabMapping.set('全部', 'all')

export const getKeyByValue = (targetValue: string) => {
  for (const [key, value] of tabMapping.entries()) {
    if (value === targetValue) return key
  }
}
export default tabMapping
